import _ from 'lodash';

const getCategories = categories => {
  let selectedCategories = [];
  for (var i in categories) {
    const categoryItem = categories[i];

    if (categoryItem.checked) {
      selectedCategories.push(categoryItem.category_id);
    }
  }
  return selectedCategories.join(',');
};

const getSubCategories = categories => {
  let selectedSubCategories = [];
  for (var i in categories) {
    const children = categories[i].children;
    for (var child in children) {
      const childItem = children[child];
      if (childItem.checked) {
        selectedSubCategories.push(childItem.id);
      }
    }
  }
  return selectedSubCategories.join(',');
};

const getMunicipality = municipality => {
  if (municipality) {
    return municipality.id;
  } else {
    return '';
  }
};

export const resetCategories = categories => {
  let newState = categories;
  for (let category in newState) {
    let group = newState[category];
    group.checked = false;
    _.forEach(group.children, c => {
      c.checked = false;
    });
  }
  return newState;
};

const getDocumentTypes = types => {
  if (types.length > 0) {
    return types.join(',');
  }
};

const mapArrToString = arr => {
  if (arr.length > 0) {
    return arr.join(',');
  }
};

export const filterData = filters => {
  getSubCategories(filters.categories);
  return {
    title: filters.search,
    mpc_id: getMunicipality(filters.municipality),
    page: filters.page || 1,
    category_id: getCategories(filters.categories),
    subcategory_id: getSubCategories(filters.categories),
    published_year: mapArrToString(filters.publishedDates),
    document_type: getDocumentTypes(filters.documentTypes),
    document_source: getDocumentTypes(filters.documentSources),
    sort_by: filters.headerSort.name,
    order_by: filters.headerSort.sort
  };
};



// WEBPACK FOOTER //
// ./src/filters/selectors/filters.js